import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Calendar, Clock, Users, Video } from 'lucide-react';

const WebinarsPage = () => {
  const upcomingWebinars = [
    { title: "Introduction to Generative AI", date: "January 20, 2026", time: "6:00 PM AEDT", speaker: "AI Expert", attendees: "150+", description: "Learn the fundamentals of generative AI and how it's transforming industries worldwide." },
    { title: "Building Your First AI Application", date: "February 5, 2026", time: "6:00 PM AEDT", speaker: "Senior AI Engineer", attendees: "200+", description: "A hands-on workshop where you'll build your first AI-powered application from scratch." },
    { title: "AI Career Pathways in 2026", date: "February 18, 2026", time: "6:00 PM AEDT", speaker: "Career Coach", attendees: "300+", description: "Discover the hottest AI careers and learn how to position yourself for success." }
  ];

  return (
    <div className="min-h-screen bg-[#F9FAFB]">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-br from-indigo-600 via-indigo-700 to-indigo-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">Free AI & Tech Webinars</h1>
            <p className="text-xl text-indigo-100 max-w-3xl mx-auto">Join our live webinars to learn from industry experts, ask questions, and connect with fellow learners</p>
          </div>
        </div>
      </section>

      {/* Upcoming Webinars */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-slate-900 mb-12 text-center">Upcoming Webinars</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {upcomingWebinars.map((webinar, idx) => (
              <div key={idx} className="bg-white rounded-2xl shadow-lg border border-gray-200 p-8 hover:shadow-2xl transition-shadow">
                <div className="w-16 h-16 bg-indigo-600 rounded-2xl flex items-center justify-center mb-6"><Video className="w-8 h-8 text-white" /></div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">{webinar.title}</h3>
                <div className="space-y-3 mb-6 text-slate-600">
                  <div className="flex items-center gap-2"><Calendar className="w-5 h-5 text-indigo-600" /><span>{webinar.date}</span></div>
                  <div className="flex items-center gap-2"><Clock className="w-5 h-5 text-indigo-600" /><span>{webinar.time}</span></div>
                  <div className="flex items-center gap-2"><Users className="w-5 h-5 text-indigo-600" /><span>{webinar.attendees} registered</span></div>
                </div>
                <p className="text-slate-700 mb-6">{webinar.description}</p>
                <button onClick={() => window.location.href = '/contact'} className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-3 rounded-xl transition-colors">Register Now</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Past Webinars / Recordings */}
      <section className="py-20 bg-[#F9FAFB]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-slate-900 mb-4 text-center">Watch Past Webinars</h2>
          <p className="text-xl text-slate-600 mb-12 text-center">Catch up on webinars you missed</p>
          <div className="text-center">
            <p className="text-slate-600 mb-6">Recordings will be available soon</p>
            <button onClick={() => window.location.href = '/contact'} className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold px-8 py-3 rounded-xl transition-colors">Get Notified</button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default WebinarsPage;
